'use client';

import { useEffect, useRef } from 'react';
import { useParams, usePathname } from 'next/navigation';
import { trackView } from './instrumentation';
import { toRouteTemplate } from './toRouteTemplate';

export function ObservabilityViewTracker() {
  const pathname = usePathname();
  const params = useParams();
  // Track by pathname change, not the computed template: /policy/A → /policy/B
  // must start a new view even though both share the name /policy/[policyId],
  // while router.refresh() (new params identity, same pathname) must not.
  const lastTrackedPathname = useRef<string | null>(null);

  useEffect(() => {
    if (lastTrackedPathname.current === pathname) return;
    lastTrackedPathname.current = pathname;
    trackView(toRouteTemplate(pathname, params ?? {}));
  }, [pathname, params]);

  return null;
}
